export default {
  SET_RESPONSIVE_MENU_OPEN(state, payload) {
    state.menuOpen = payload
  }
}